module.exports = __webpack_public_path__ + "static/img/ical_1.4ae01c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/integrations/ical_1.png
// module id = 1426
// module chunks = 1